export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Semibold.2e9fd49ffef109121ce47043f570be3a.eot";